import React from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import { getCombatChartData } from "../utils/coachStatsUtils";

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;

  const item = payload[0];

  return (
    <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm shadow-xl dark:border-white/10 dark:bg-slate-900">
      <p className="font-bold text-slate-950 dark:text-white">
        {item.name}
      </p>
      <p className="text-slate-500 dark:text-white/60">
        {item.value} combat{item.value > 1 ? "s" : ""}
      </p>
    </div>
  );
}

function CenterLabel({ stats }) {
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <div className="text-center">
        <p className="font-titre text-4xl font-bold text-slate-950 dark:text-white">
          {stats.totalCombats}
        </p>
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
          combats
        </p>
      </div>
    </div>
  );
}

function CombatResultsDonut({ stats }) {
  const data = getCombatChartData(stats);
  const hasData = data.some((item) => item.value > 0);

  return (
    <article className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700 dark:text-sky-200">
            Combats
          </p>

          <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Résultats des combats
          </h2>
        </div>

        <span className="rounded-full bg-sky-100 px-3 py-1 text-xs font-bold text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
          {stats.victoryRate}% victoire
        </span>
      </div>

      <div className="relative mt-4 h-[320px]">
        {hasData ? (
          <>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <defs>
                  <filter id="donutShadow" height="130%">
                    <feDropShadow
                      dx="0"
                      dy="8"
                      stdDeviation="7"
                      floodOpacity="0.18"
                    />
                  </filter>
                </defs>

                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  dataKey="value"
                  nameKey="name"
                  innerRadius="62%"
                  outerRadius="82%"
                  paddingAngle={4}
                  cornerRadius={10}
                  filter="url(#donutShadow)"
                >
                  {data.map((entry) => (
                    <Cell key={entry.name} fill={entry.color} />
                  ))}
                </Pie>

                <Tooltip content={<CustomTooltip />} />
                <Legend
                  verticalAlign="bottom"
                  iconType="circle"
                  wrapperStyle={{
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                />
              </PieChart>
            </ResponsiveContainer>

            <CenterLabel stats={stats} />
          </>
        ) : (
          <div className="flex h-full items-center justify-center rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50 text-sm font-bold text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
            Aucun combat saisi
          </div>
        )}
      </div>
    </article>
  );
}

export default CombatResultsDonut;